import { render, staticRenderFns } from "./countries.vue?vue&type=template&id=3bcd536c&scoped=true&"
import script from "./countries.vue?vue&type=script&lang=js&"
export * from "./countries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcd536c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bcd536c')) {
      api.createRecord('3bcd536c', component.options)
    } else {
      api.reload('3bcd536c', component.options)
    }
    module.hot.accept("./countries.vue?vue&type=template&id=3bcd536c&scoped=true&", function () {
      api.rerender('3bcd536c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/countries.vue"
export default component.exports